import { ITranslations } from "../data/strings";
import IFamily, { EAge } from "./IFamily";

export interface IMediaToolkitProps {}

export type TBreakpoint = "xs" | "sm" | "md" | "lg" | "xl" | "2xl";

export enum ELCID {
    "English" = 1033,
    "Spanish" = 3082,
}

export interface IMediaToolkitNavPage {
    title: string;
    description: string;
    family: IFamily;
    pages: IMediaPlanPage[];
    topics: IMediaToolkitDataTopic[];
    ctaMap: JSX.Element;
    backButton: JSX.Element;
    continueButton: JSX.Element;
    readonly: boolean;
    lcid: ELCID;
    footer?: string;
}

export interface AAPMediaToolkitPageData {
    ScreenDataJSON: IMediaToolkitDataTopic[];
    CalculatorListJSON: any;
    PageVerbiageJSON: IAAPMediaToolkitVerbiageData;
    PageTranslationJSON: ITranslations;
    LCID: string;
    LoggedIn: boolean;
    CurrentUser?: AAPMediaToolkitCurrentUserInfo;
    ErrorData?: string;
}

export interface AAPMediaToolkitCurrentUserInfo {
    Key: string;
    FirstName: string;
    LastName: string;
    MiddleName: string;
    Gender: string;
    CareGiverType: string;
    IsPregnant: boolean;
    DueDate: string;
    Children: AAPMediaToolkitCurrentUserChild[];
    Sponsors: string[];
    ReceiveAAPInfo: boolean;
    ReceiveNewsletters: boolean;
    Newsletters: string[];
    TopicsOfInterest: string[];
    OtherInterests: string;
}

export interface AAPMediaToolkitCurrentUserChild {
    Key: string;
    DateOfBirth: string;
    Month: string;
    Year: string;
    Name: string;
    Gender: string;
    Delete: boolean;
    FeaturedArticles: null;
    ImageURL: string;
}

export interface IAAPMediaToolkitVerbiageData {
    "calculator-footer": string;
    "calculator-intro": string;
    "calculator-title": string;
    "hero-image": string;
    "homepage-footer": string;
    "homepage-intro": string;
    "homepage-title": string;
    "planview-footer": string;
    "planview-intro": string;
    "planview-title": string;
    "wizard-footer": string;
    "wizard-intro": string;
    "wizard-title": string;
    "wizard-shortDescription": string;
    "tutorial-title": string;
    "tutorial-intro": string;
    "tutorial-footer": string;
    "tutorial-shortDescription": string;
    "tutorial-videoUrl": string;
    "reason-scienceTitle": string;
    "reason-talkingpointsTitle": string;
    "global-footer": string;
}

export interface IMediaToolkitState {
    loading: boolean;
    initiallyLoaded: boolean;
    isLoggedIn: boolean;
    isOnline: boolean;
    planPages: IMediaPlanPage[];
    navScrollTop: number;
    curBreakpoint: TBreakpoint;
    toolInfo: AAPMediaToolkitPageData | null;
    mediaToolkitData: IMediaToolkitDataTopic[];
    mediaToolkitVerbiageData: IAAPMediaToolkitVerbiageData;
    saving: boolean;
    myPlans: IAAPServerPlan[];
    selectedPlan: IAAPServerPlan;
    selectedPlanFamily: IFamily;
    userHasSavedPlanOnAccount: boolean;
    localAndRemotePlansMatch: boolean;
    guestPlanLoaded: boolean;
    guestPlanName: string | null;
    isViewingGuest: boolean;
    lcid: ELCID;
    translations: ITranslations;
    currentUser?: AAPMediaToolkitCurrentUserInfo;
}

export interface IMediaPlanPage {
    spoId: number;
    title: string;
    identifier: string;
    icon: string;
    navigateTo: string;
    description?: string;
    availablePriority?: boolean;
    isPriority?: boolean;
    dontCountAsStep?: boolean;
    hideForGuestView?: boolean;
    showAlways?: boolean;
}

export interface IMediaToolkitDataTopic {
    id: number;
    title: string;
    description: string;
    promises: IPromise[];
    order: string;
    enabledByDefault: boolean;
    icon?: string;
    points?: IPromisePoints;
}

export interface IPromisePoints {
    General?: IPromisePoint[];
    "0-17 months"?: IPromisePoint[];
    "18-24 months"?: IPromisePoint[];
    "2-5 years"?: IPromisePoint[];
    "6-12 years"?: IPromisePoint[];
    "13-18 years"?: IPromisePoint[];
}

export interface IPromise {
    id: number;
    title: string;
    order: string;
    icon?: string;
    allPoints?: IPromisePoint[];
    points?: IPromisePoints;
    description?: string;
}

export interface IPromisePoint {
    id: number;
    title: string;
    order: string | null;
    description: string | null;
    icon?: string;
    additionalInfo?: string | null;
    targetAges?: EAge[];
    isCustom?: boolean;
}
export interface IAAPServerPlanBase {
    json_encrypted: string;
    plan_guid: string;
    is_public: boolean;
    hide_child_names: boolean;
    hide_last_name: boolean;
    plan_password_hash: string;
    id: number | null;
}

export interface IAAPServerPlan extends IAAPServerPlanBase {
    family: IFamily;
}

export interface IAAPServerPlanWritable extends IAAPServerPlanBase {
    json_raw: string;
}

export enum EAAPRequestTypes {
    "getfullplandata" = "getfullplandata",
    "getsharedplan" = "getsharedplan",
    "getmyplans" = "getmyplans",
    "insertplan" = "insertplan",
    "deleteplan" = "deleteplan",
    "updateplan" = "updateplan",
    "emailplan" = "emailplan",
}

export interface IAAPServerPlanPayloadBase {
    type: EAAPRequestTypes;
}

export interface IAAPServerPlanPayloadInsert extends IAAPServerPlanPayloadBase {
    planInfo: IAAPServerPlanWritable;
}
export interface IAAPServerPlanPayloadGetGuest extends IAAPServerPlanPayloadBase {
    plan_guid: string;
}

export interface IAAPServerPlanPayloadDelete extends IAAPServerPlanPayloadBase {
    id: number;
}

export interface IAAPServerPlanPayloadEMail extends IAAPServerPlanPayloadBase {
    mediaPlanUrl: string;
    toAddress: string;
}
